require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./member-ralph-tiburdo.json") })
        }
      }, "path---member-ralph-tiburdo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---member-ralph-tiburdo!./.cache/json/member-ralph-tiburdo.json
// module id = 407
// module chunks = 231608221292675